import React, { Component } from 'react';
import cx from 'classnames';
import moment from 'moment';
import { getMoment } from '@shootsta/get-moment';
import { List, Button, Icon, Carousel, Text, NUMERIC_MEDIA_SIZES } from '../../../ui-kit';
import readableStat from '../utils/readableStat';
import '../styles/_analytics-banner.scss';

























const CAROUSEL_DEFAULT_CONFIG = {
  variableWidth: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]

};

// TypeScript & flow likely do this even better, though can refactor later if it only ends up in stories/tests...
export const FILTERS_ENUM = Object.freeze({
  TODAY: 'TODAY',
  THIS_MONTH: 'THIS_MONTH',
  ALL_TIME: 'ALL_TIME'
});

const UNIX_EPOCH = '1970-01-01T00:00:00.000Z';

const FILTER_OPTION_TO_CREATED_AT = {
  [FILTERS_ENUM.TODAY]: moment.utc().startOf('day').toISOString(),
  [FILTERS_ENUM.THIS_MONTH]: moment.utc().startOf('month').toISOString(),
  [FILTERS_ENUM.ALL_TIME]: UNIX_EPOCH
};

const DEFAULT_FILTERS = [
{ id: FILTERS_ENUM.TODAY, label: 'Today' },
{ id: FILTERS_ENUM.THIS_MONTH, label: 'This Month' },
{ id: FILTERS_ENUM.ALL_TIME, label: 'All Time' }];


export default class AnalyticsBanner extends Component


{
  state = {
    selectedFilter: FILTERS_ENUM.THIS_MONTH,
    stats: [],
    toggleFiltersVisible: false
  };

  static defaultProps = {
    filters: DEFAULT_FILTERS
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedFilter } = this.state;
    const { directInfo } = this.props;

    if (prevState.selectedFilter !== selectedFilter ||
    directInfo && prevState.stats !== directInfo) {
      this.fetchData();
    }
  }

  fetchData = async () => {
    const {
      getLandingPageAnalytics,
      directInfo,
      productName: productShortName
    } = this.props;

    const { selectedFilter } = this.state;
    const createdAt = [FILTER_OPTION_TO_CREATED_AT[selectedFilter]];

    if (directInfo) {
      this.setState({ stats: directInfo });
      return;
    }

    if (getLandingPageAnalytics) {
      const { data, errors } = await getLandingPageAnalytics({
        createdAt,
        productShortName
      });
      if (errors || !data || !data.getLandingPageAnalytics) {
        this.setState({ stats: [{ label: 'There was an error fetching statistics', value: '' }] });
        return;
      }
      this.setState({ stats: data.getLandingPageAnalytics.stats });
      return;
    }

    this.setState({ stats: [{ label: 'There was an error fetching statistics', value: '' }] });
  };

  render() {
    const {
      className = '',
      filters,
      productName,
      timezone,
      width,
      title,
      hideTimeFiltering,
      carouselConfig
    } = this.props;
    const {
      selectedFilter,
      stats,
      toggleFiltersVisible
    } = this.state;

    const CAROUSEL_CONFIG = {
      ...CAROUSEL_DEFAULT_CONFIG,
      carouselConfig
    };

    const startCreatedDate = getMoment(FILTER_OPTION_TO_CREATED_AT[selectedFilter]).format('DD MMM HH:mm');
    const isSmall = width < NUMERIC_MEDIA_SIZES.small;

    if (!isSmall) {
      return (
        <header
          className={cx('analytics-banner', className, {
            'analytics-banner__small': isSmall
          })}>

          <div className="analytics-banner__header">
            <Text heading3>
              {title || `Your latest ${productName} stats`}
            </Text>
            {hideTimeFiltering ||

            <div className="analytics-banner__filters-list">
                {timezone && selectedFilter === FILTERS_ENUM.THIS_MONTH ?
              <Text className="analytics-banner__filters-list__date">
                    {`from ${startCreatedDate} ${timezone}`}
                  </Text> :
              null}
                {timezone && selectedFilter === FILTERS_ENUM.TODAY ?
              <Text className="analytics-banner__filters-list__date">
                    {`from ${startCreatedDate} ${timezone}`}
                  </Text> :
              null}
                {filters && filters.map(({ label, id }) =>
              <Button
                onClick={() => this.setState({ selectedFilter: id })}
                className={selectedFilter === id ? 'analytics-banner__filters-item analytics-banner__filters-item__selected-filter-item' : 'analytics-banner__filters-item'}>

                    <span>{label}</span>
                  </Button>
              )}
              </div>}


          </div>
          <div className="analytics-banner__list">
            {stats.map(({ label, value }) =>
            <>
                {/* $FlowFixMe */}
                <List.CardItem className="analytics-banner__list-item">
                  <p>{label}</p>
                  <b>{readableStat(value)}</b>
                </List.CardItem>
              </>
            )}
          </div>
        </header>);

    }
    return (
      <header
        className={cx('analytics-banner', className, {
          'analytics-banner__small': isSmall
        })}>

        <div className="analytics-banner__header">
          <Text heading4 className="analytics-banner__header__mobile">
            {title || `Your latest ${productName} stats`}
            {hideTimeFiltering ||
            <Icon name="preferences" className={toggleFiltersVisible ? 'analytics-banner__header__mobile__icon analytics-banner__header__mobile__icon__selected' : 'analytics-banner__header__mobile__icon'} size={20} onClick={() => this.setState({ toggleFiltersVisible: !toggleFiltersVisible })} />}

          </Text>
          {toggleFiltersVisible && !hideTimeFiltering ?
          <>
              <div className="analytics-banner__filters-list">
                {filters && filters.map(({ label, id }) =>
              <Button
                onClick={() => this.setState({ selectedFilter: id })}
                className={selectedFilter === id ? 'analytics-banner__filters-item analytics-banner__filters-item__selected-filter-item' : 'analytics-banner__filters-item'}>

                    <span>{label}</span>
                  </Button>
              )}
              </div>
              {timezone && selectedFilter === FILTERS_ENUM.THIS_MONTH ?
            <Text className="analytics-banner__filters-list__date">
                  {`from ${startCreatedDate} ${timezone}`}
                </Text> :
            null}
              {timezone && selectedFilter === FILTERS_ENUM.TODAY ?
            <Text className="analytics-banner__filters-list__date">
                  {`from ${startCreatedDate} ${timezone}`}
                </Text> :
            null}
            </> :
          null}
        </div>
        <div className="analytics-banner__slider">
          <Carousel itemWidth={250} config={CAROUSEL_CONFIG} data-testid="carousel">
            {stats.map(({ label, value }) =>
            <>
                {/* $FlowFixMe */}
                <List.CardItem className="analytics-banner__list-item">
                  <p>{label}</p>
                  <b>{readableStat(value)}</b>
                </List.CardItem>
              </>
            )}
          </Carousel>
        </div>
      </header>);

  }
}